import type { ReactNode } from 'react';
import { useSearchParams } from 'react-router';

export interface TabDef<T extends string> {
  value: T;
  label: ReactNode;
  /** Hidden when false (permission). */
  show?: boolean;
}

/** The current tab from `?tab=`, falling back to the first visible tab. */
export function useUrlTab<T extends string>(tabs: TabDef<T>[]): [T, (t: T) => void] {
  const [params, setParams] = useSearchParams();
  const visible = tabs.filter((t) => t.show !== false);
  const first = visible[0]?.value ?? tabs[0]?.value;
  const raw = params.get('tab');
  const current = (visible.find((t) => t.value === raw)?.value ?? first) as T;
  // A new tab starts with clean filters. Switching is a step Back returns from, so no replace.
  const set = (t: T) => setParams(() => (t !== first ? { tab: t } : new URLSearchParams()));
  return [current, set];
}
